module.exports = __webpack_public_path__ + "media/evolve/assets/icons/static/changelog-5248c93263d7056afe1a9f757a543b47.svg";